var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1556 8.00851C16.1556 3.59185 12.5588 0.0085144 8.12549 0.0085144C3.69222 0.0085144 0.0954132 3.59185 0.0954132 8.00851C0.0954132 12.4252 3.69222 16.0085 8.12549 16.0085C12.5588 16.0085 16.1556 12.4252 16.1556 8.00851Z",
    fill: "#00D73C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.905 5.31981C13.261 4.89758 13.2073 4.26669 12.7851 3.91069C12.3629 3.55468 11.732 3.60837 11.376 4.03059L12.905 5.31981ZM6.51944 11.3419L5.77739 12.0122C5.97099 12.2265 6.24777 12.3467 6.53652 12.3417C6.82527 12.3368 7.09779 12.2073 7.28395 11.9865L6.51944 11.3419ZM4.85246 8.00485C4.48223 7.59503 3.84988 7.56293 3.44006 7.93316C3.03024 8.30338 2.99814 8.93573 3.36837 9.34555L4.85246 8.00485ZM11.376 4.03059L5.75492 10.6973L7.28395 11.9865L12.905 5.31981L11.376 4.03059ZM7.26148 10.6715L4.85246 8.00485L3.36837 9.34555L5.77739 12.0122L7.26148 10.6715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.9ac144510495e5dc8c71c340b511fdc0.svg";
export { ForwardRef as ReactComponent };